import updeep from 'updeep';
import {
  COMPANY_SET,
  UPDATE_COMPANY_PROFILE_ID,
  UPDATE_COMPANY_PROFILE,
  UPDATE_COMPANY,
} from '@src/redux/actions/company';

export function company(state = null, action) {
  switch (action.type) {
    case COMPANY_SET:
      return action.company;
    case UPDATE_COMPANY_PROFILE_ID:
      return updeep.updateIn('profile.id', action.id, state);
    case UPDATE_COMPANY_PROFILE:
      return { ...state, profile: action.profile };
    case UPDATE_COMPANY:
      return { ...state, ...action.company };
    default:
      return state;
  }
}
